import {useStockInformationQuery} from "./useStockInformationQuery";

export const useMinimumQuantity = () => {
    const {model} = useStockInformationQuery()
    const minimumSaleQuantity = model?.minimumQuantity ?? 1
    return {minimumSaleQuantity: minimumSaleQuantity};
};